import React from 'react';
import PropTypes from 'prop-types';
import { TranslatedBadge } from './translated_badge';

function InstantCashBadge({ amountCash, amountTyres, color }) {
    return (
        <TranslatedBadge
            type="instant-cash"
            translationKey="badge-instant-cash"
            placeholder={{ amountCash, amountTyres }}
            color={color}
        />
    );
}

InstantCashBadge.propTypes = {
    amountCash: PropTypes.string.isRequired,
    amountTyres: PropTypes.number.isRequired
};

export { InstantCashBadge };
